import { CitationType } from 'api/citation/types';
import { SignalCitation } from 'api/signal/types';
import ReactMarkdown, { Components } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import { preprocessMessageWithCitations } from 'utils/citation-preprocessor';
import { CitationDataPopover } from 'components/organisms/document-editor/extensions/citation/ui/citation-data-popover';

const StyledCitationPopover = styled(CitationDataPopover)`
  display: inline-block;
`;
const StyledP = styled.p`
  margin-bottom: 0px;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  &:first-child {
    margin-top: 0px;
  }
  &:last-child {
    margin-bottom: 0px;
  }
`;

interface TextWithCitationsProps {
  value: string;
  citationMapping?: SignalCitation;
}
export const TextWithCitations = ({
  value: text,
  citationMapping,
}: TextWithCitationsProps) => {
  const createMarkdownComponents = (): Partial<Components> => ({
    cite: (props: any) => {
      const citationNum = props['data-num'];

      return (
        <StyledCitationPopover
          label={citationNum}
          citationId={citationMapping?.[citationNum]?.citationUuid ?? 0}
          citationType={
            citationMapping?.[citationNum]?.citationType as CitationType
          }
        />
      );
    },
    p: ({ node, ...props }: any) => {
      return <StyledP {...props} key={node.key} />;
    },
  });

  const markdownComponents = createMarkdownComponents();

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[[rehypeRaw]]}
      components={markdownComponents}
    >
      {preprocessMessageWithCitations(text)}
    </ReactMarkdown>
  );
};
